import React from "react";
import { useContext } from "react";
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AnimatePresence } from "framer-motion";
import { MainInfoWrapper } from "./MainInfoWrapper";
import Home from "./Home";
import Header from "./Header";
import GeneralInfo from './GeneralInfo';
import Map from './Map';


const AnimatedRoutes = () => {


    const { allInfo } = useContext(MainInfoWrapper)

    const location = useLocation() // useLocation is the only way to make Routes animation work (comparing to animation on an element inside a component)

    const isInIFrame = (window.location !== window.parent.location) ? true : false;
    if (isInIFrame) {
        console.log('The website is inside an iFrame')
    } else {
        console.log('The website is NOT inside an iFrame')
    }
    
    return (
        <div>
            <Header isInIFrame={isInIFrame}/>
            <AnimatePresence mode={"wait"}>
                <Routes location={location} key={location.pathname} >
                    <Route path='/' element={<Home isInIFrame={isInIFrame}/>} />
                    <Route path='/general-info' element={<GeneralInfo isInIFrame={isInIFrame}/>} /> 
                    
                    {allInfo.map((item) => (
                        <Route key={item.id} path={item.path} element={item.elem} />
                    ))}  
                    
                    <Route path='/map' element={<Map isInIFrame={isInIFrame}/>} /> 
                    <Route path='*' element={<Navigate to='/' />} />
                </Routes>
            </AnimatePresence>
        </div>
    );
}
 
export default AnimatedRoutes;